import InfoBox from 'components/InfoBox';
import Text from 'components/base/Text';

const OrderInfoBox = () => {
  return (
    <InfoBox
      mt={null}
      mb='small'
      icon='alert'
      iconAlign='center'
      iconColor='orangePeel'
      backgroundColor='orangePeel'
      backgroundAlpha={0.1}
      borderColor='orangePeel'
      borderAlpha={0.2}
      width='fit-content'
    >
      <Text size='medium' pl='0.5rem' weight='400'>
        <b>Category order is important!</b> Rules are met on a first match base,
        reorder categories as needed.
      </Text>
    </InfoBox>
  );
};

export default OrderInfoBox;
